import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class BreedActions extends Actions{
    static get target(){
        return 'breeds'
    }
}


// WEBPACK FOOTER //
// ./actions/BreedActions.js